import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import type { Product } from '../../algolia/interfaces/product';
import type { TypedListingState } from '../model';

export const selectListing = <P extends Product = Product>(
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): TypedListingState<P> | undefined =>
  state.productDiscovery?.listing as TypedListingState<P>;
